import script from "./DonationFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationFormView.vue?vue&type=script&setup=true&lang=ts"

import "./DonationFormView.vue?vue&type=style&index=0&id=0cc9dd61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc9dd61"]])

export default __exports__